export const casper = 'casper'
const casper_route = {
    casper:`/${casper}`
}

export default casper_route
